var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24902 6.64258H5.24902H21.249",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.249 6.64258V20.6426C19.249 21.173 19.0383 21.6817 18.6632 22.0568C18.2882 22.4319 17.7795 22.6426 17.249 22.6426H7.24902C6.71859 22.6426 6.20988 22.4319 5.83481 22.0568C5.45974 21.6817 5.24902 21.173 5.24902 20.6426V6.64258M8.24902 6.64258V4.64258C8.24902 4.11215 8.45974 3.60344 8.83481 3.22836C9.20988 2.85329 9.71859 2.64258 10.249 2.64258H14.249C14.7795 2.64258 15.2882 2.85329 15.6632 3.22836C16.0383 3.60344 16.249 4.11215 16.249 4.64258V6.64258",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.249 11.6426V17.6426",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.249 11.6426V17.6426",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7c5411e841744b13b21d61a3775a3a55.svg";
export { ForwardRef as ReactComponent };